export default "__VITE_ASSET__Bzw$R$iT__"